<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Administrator Tools</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-card-content>
        <cs-item-list>
          <cs-item-divider color="canvas">General configuration</cs-item-divider>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminConfigPage)" [label]="'Config Variables' | untranslated"></cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminTextListPage)" [label]="'Help Texts' | untranslated"></cs-button>
          </cs-item>
          <cs-item-divider color="canvas">Workout configuration</cs-item-divider>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminExerciseListPage)" [label]="'Exercises' | untranslated"></cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminExerciseSlotListPage)" [label]="'Exercise Slots' | untranslated"></cs-button>
          </cs-item>
          <cs-item-divider color="canvas">Nutrition databases</cs-item-divider>
          <cs-item>
            <cs-button item-right (click)="publishUnpublishedFood()" [label]="'Publish Unpublished Food' | untranslated"></cs-button>
          </cs-item>
          <cs-item-divider color="canvas">Users</cs-item-divider>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminUserSearchPage)" [label]="'Find User(s)' | untranslated"></cs-button>
          </cs-item>
          <cs-item>
            <cs-button item-right (click)="navCtrl.pushAsync(IAdminKeygenPage)" [label]="'Generate Activation Keys' | untranslated"></cs-button>
          </cs-item>
          @if (isImpersonating) {
            <cs-item>
              <cs-button item-right (click)="navCtrl.pushAsync(IAdminImpersonatedUserPage)" [label]="'Impersonated User' | untranslated"></cs-button>
            </cs-item>
          }
        </cs-item-list>
      </cs-card-content>
    </cs-card>
  </cs-card-list>

</cs-content>
